module.exports = __webpack_public_path__ + "static/edit-banner-promo-text-on-top-left-header-416c66074d3938eb204697596749185f.png";